export const Checkbox = {
  baseStyle: {
    control: {
      border: '1px solid',
    },
  },
};
